/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';

const OptionArea = ({
  disabled,
  className,
  children,
  isSelected,
  handleChangeOption,
  label,
  subLabel,
  withRadioButton,
}) => (
  <div
    className={`p-3 select-option ${className}`}
    onClick={disabled ? null : handleChangeOption}
    role="button"
    tabIndex={-1}
    onKeyDown={() => {}}
    disabled={!!disabled}
    active={isSelected ? 'true' : 'false'}>
    <div className="flex-row-center w-100 justify-content-between">
      <div className="w-90">
        <b className="text-f5 label">{label}</b>
        <p className="text-f6 sublabel text-truncate d-block w-100">{subLabel}</p>
      </div>
      {withRadioButton && (
        <div className="form-check-label pe-none w-10">
          <p className="text-dark text-f5">
            <input
              disabled={disabled}
              type="radio"
              className="form-check-input"
              checked={isSelected}
              onChange={handleChangeOption}
            />
          </p>
        </div>
      )}
    </div>
    {children}
  </div>
);

export default OptionArea;

OptionArea.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isSelected: PropTypes.bool.isRequired,
  handleChangeOption: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  withRadioButton: PropTypes.bool,
};
OptionArea.defaultProps = {
  subLabel: null,
  className: null,
  children: null,
  disabled: null,
  withRadioButton: true,
};
